import { Component } from '@angular/core';

@Component({
  selector: 'app-electronic-billing-afip-status',
  templateUrl: './electronic-billing-afip-status.component.html',
  styleUrls: ['./electronic-billing-afip-status.component.scss'],
})
export class ElectronicBillingAfipStatusComponent {}
